/**
 * PDP gallery overlays — first-slide binding.
 *
 * Award badges and the Defacto "Lab Tested" button belong to the first gallery
 * image only, so the anchor is flagged as soon as the customer moves to another
 * slide and CSS hides both overlays. That covers variant switching too: the
 * variant handlers move the gallery via Flickity, which fires the same 'change'
 * event we listen for here.
 *
 * Binding is per anchor rather than per overlay because the Defacto button is
 * injected later by the app's script (custom selector in settings_data.json
 * targets the anchor) and exists on products with no award badges.
 *
 * Flickity is initialised by an inline script further down the page, so this
 * retries briefly until the instance exists. If it never does — a single-image
 * gallery with no carousel — the badges are simply left visible, which is the
 * correct result for a product with one image.
 */
(function () {
  var MAX_ATTEMPTS = 40;
  var RETRY_DELAY = 125;
  var SELECTOR = '.award-badges__anchor';
  var OFF_FIRST_CLASS = 'award-badges__anchor--off-first';

  /**
   * Returns true when the anchor is resolved and needs no further attempts,
   * false when Flickity isn't ready yet and we should retry.
   */
  function bind(anchor) {
    var slider = anchor.querySelector('.carousel.product__image-slider');

    if (!slider) {
      return true;
    }

    if (typeof window.Flickity === 'undefined') {
      return false;
    }

    var instance = window.Flickity.data(slider);

    if (!instance) {
      return false;
    }

    var sync = function () {
      anchor.classList.toggle(OFF_FIRST_CLASS, instance.selectedIndex !== 0);
    };

    instance.on('change', sync);
    sync();

    return true;
  }

  function init() {
    var pending = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));

    if (!pending.length) {
      return;
    }

    var attempts = 0;

    (function attempt() {
      pending = pending.filter(function (anchor) {
        return !bind(anchor);
      });

      attempts += 1;

      if (pending.length && attempts < MAX_ATTEMPTS) {
        window.setTimeout(attempt, RETRY_DELAY);
      }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
